
import { Vue, Component, Prop } from "vue-property-decorator";
import {CreateElement, VNode} from "vue/types";
import {BreadcrumbsConfig, BreadcrumbItem} from "water-rest/src/model/GlobalTypes";

@Component({})
export default class Breadcrumbs extends Vue {

  toRoute(to: string | undefined) {
    if ( !to ) return;
    this.$router.push(to);
  }

  buildDropdownItem(slotItem: BreadcrumbItem): VNode | null {
    if ( !slotItem.to ) return null;
    return this.$createElement(
        'w-r-dropdown-item',
        {
          props: {
            title: slotItem.title
          },
          on: {
            click: () => this.toRoute(slotItem.to)
          }
        }
    );
  }

  buildLink(item: BreadcrumbItem): VNode {
    if ( item.active || !item.to )
      return this.$createElement(
          'span',
          {},
          item.title
      );
    return this.$createElement(
        'router-link',
        {
          props: {
            to: item.to
          }
        },
        item.title
    )
  }

  buildBreadcrumbItem(item: BreadcrumbItem): VNode {
    return this.$createElement(
        'li',
        {
          staticClass: 'w-r-breadcrumb-item',
          class: [
            {
              active: item.active
            }
          ]
        },
        [this.buildLink(item)]
    )
  }

  prepareList(slotItems: VNode[]): VNode[] {
    const preparedList: VNode[] = [];

    for (let i = 0; i < slotItems.length; i++) {
      preparedList.push(slotItems[i]);
      preparedList.push(
            this.$createElement(
                'r-icon',
                {
                  props: {
                    icon: 'arrow-right',
                    size: 8
                  }
                }
            )
        );
    }

    return preparedList;
  }

  render(h: CreateElement): VNode | null {
    const breadcrumbs: BreadcrumbsConfig = this.$store.getters.breadcrumbs;
    if ( !breadcrumbs || breadcrumbs.items.length === 0 ) return null;
    const breadcrumbItems = breadcrumbs.items.map( bi => this.buildBreadcrumbItem(bi) );

    if (breadcrumbs.items.length > breadcrumbs.before + breadcrumbs.after) {
      const firstPart = breadcrumbs.items.slice(0, breadcrumbs.before).map( bi => this.buildBreadcrumbItem(bi) );
      const dropDownPart = breadcrumbs.items.slice(
          breadcrumbs.before,
          breadcrumbs.items.length - breadcrumbs.after
      );
      const lastPart = breadcrumbs.items.slice(-breadcrumbs.after).map( bi => this.buildBreadcrumbItem(bi) );

      const listItems = dropDownPart.map( ddp => this.buildDropdownItem(ddp) );

      const dropDown = h(
          'w-r-dropdown',
          {
            props: {
              position: 'left-bottom'
            }
          },
          [
            h(
                'r-button',
                {
                  slot: 'activator',
                  props: {
                    size: 'polyxo',
                    title: '...',
                    rounded: false,
                    type: 'secondary'
                  },
                },
            ),
            listItems
          ]
      );

      return h(
          'ol',
          {
            staticClass: 'w-r-breadcrumb'
          },
          [...this.prepareList([...firstPart, dropDown, ...lastPart])]);
    }

    return h(
        'ol',
        {
          staticClass: 'w-r-breadcrumb'
        },
        [...this.prepareList(breadcrumbItems)]
    );
  }
}
